import { render, staticRenderFns } from "./ResourceUploadBtn.vue?vue&type=template&id=f0425f52&scoped=true"
import script from "./ResourceUploadBtn.vue?vue&type=script&lang=js"
export * from "./ResourceUploadBtn.vue?vue&type=script&lang=js"
import style0 from "./ResourceUploadBtn.vue?vue&type=style&index=0&id=f0425f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0425f52",
  null
  
)

export default component.exports